let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ansMy")).then(() => parcelRequire('9c7ho'));